import { render, staticRenderFns } from "./invoices-detail-table-panel.vue?vue&type=template&id=4dfe2eb9&scoped=true&lang=pug"
import script from "./invoices-detail-table-panel.vue?vue&type=script&lang=js"
export * from "./invoices-detail-table-panel.vue?vue&type=script&lang=js"
import style0 from "./invoices-detail-table-panel.vue?vue&type=style&index=0&id=4dfe2eb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe2eb9",
  null
  
)

export default component.exports